var map = {
	"./丁村遗址1.png": 39123,
	"./丁村遗址2.png": 91585,
	"./丁村遗址3.png": 57872,
	"./七里亭遗址1.png": 73346,
	"./七里亭遗址2.png": 68794,
	"./七里亭遗址3.png": 29118,
	"./七里亭遗址4.png": 75634,
	"./万寿岩遗址1.png": 39585,
	"./万寿岩遗址2.png": 79198,
	"./万寿岩遗址3.png": 60104,
	"./万寿岩遗址4.png": 65558,
	"./万寿岩遗址5.png": 50792,
	"./万寿岩遗址6.png": 92003,
	"./万寿岩遗址7.png": 92832,
	"./万寿岩遗址8.png": 33201,
	"./万寿岩遗址9.png": 16816,
	"./上马坎遗址1.png": 37946,
	"./上马坎遗址2.png": 42612,
	"./上马坎遗址3.png": 74695,
	"./上马坎遗址4.png": 1952,
	"./中华曙猿化石地点1.png": 41346,
	"./中华曙猿化石地点2.png": 35985,
	"./乌龟洞1.png": 32927,
	"./乌龟洞2.png": 3723,
	"./人字洞遗址1.png": 20404,
	"./信冲洞遗址1.png": 15922,
	"./元谋猿人遗址1.png": 35559,
	"./元谋猿人遗址2.png": 45569,
	"./前阳洞穴遗址1.png": 37045,
	"./匼河遗址1.png": 41719,
	"./华龙洞遗址1.png": 20229,
	"./古交遗址1.png": 61374,
	"./古交遗址2.png": 89978,
	"./古交遗址3.png": 66280,
	"./合溪洞遗址1.png": 57307,
	"./合溪洞遗址2.png": 44396,
	"./合溪洞遗址3.png": 35193,
	"./合溪洞遗址4.png": 73025,
	"./周口店遗址群1.png": 42671,
	"./周口店遗址群2.png": 21157,
	"./和县猿人遗址1.png": 92413,
	"./和县猿人遗址2.png": 75420,
	"./和龙大洞遗址1.png": 22437,
	"./和龙大洞遗址2.png": 21616,
	"./和龙大洞遗址3.png": 29643,
	"./和龙大洞遗址4.png": 46469,
	"./和龙大洞遗址5.png": 4569,
	"./和龙大洞遗址6.png": 30105,
	"./和龙大洞遗址7.png": 61843,
	"./四方洞遗址1.png": 78682,
	"./四方洞遗址2.png": 37397,
	"./塔水河遗址1.png": 38296,
	"./大窑遗址1.png": 77107,
	"./大窑遗址2.png": 10253,
	"./孙家洞遗址1.png": 27757,
	"./学堂梁子遗址1.png": 22780,
	"./学堂梁子遗址2.png": 84700,
	"./学堂梁子遗址3.png": 39356,
	"./小长梁遗址1.png": 30279,
	"./小长梁遗址2.png": 93323,
	"./小长梁遗址3.png": 79290,
	"./尼阿底遗址1.png": 15200,
	"./尼阿底遗址2.png": 33169,
	"./尼阿底遗址3.png": 45450,
	"./尼阿底遗址4.png": 59054,
	"./山顶洞人1.png": 33117,
	"./山顶洞人2.png": 54225,
	"./峙峪遗址1.png": 97671,
	"./峙峪遗址2.png": 24684,
	"./峙峪遗址3.png": 34283,
	"./巨家塬遗址1.png": 88005,
	"./巫山猿人遗址（龙骨坡遗址）1.png": 74613,
	"./巫山猿人遗址（龙骨坡遗址）2.png": 35055,
	"./巫山猿人遗址（龙骨坡遗址）3.png": 23514,
	"./庙后山遗址1.png": 50368,
	"./庙后山遗址2.png": 27151,
	"./建始直立人遗址1.png": 34959,
	"./杨家坟山遗址1.png": 53645,
	"./柿子滩遗址1.png": 5281,
	"./柿子滩遗址2.png": 66537,
	"./柿子滩遗址3.png": 99126,
	"./柿子滩遗址4.png": 15023,
	"./毛竹山、官山遗址1.png": 55665,
	"./毛竹山、官山遗址2.png": 3335,
	"./水洞沟遗址1.png": 12544,
	"./水洞沟遗址2.png": 90963,
	"./水洞沟遗址3.png": 7763,
	"./水洞沟遗址4.png": 31315,
	"./沂源猿人化石遗址1.png": 92750,
	"./沂源猿人化石遗址2.png": 51670,
	"./泥河湾遗址群1.png": 72608,
	"./泥河湾遗址群2.png": 86472,
	"./泥河湾遗址群3.png": 45379,
	"./洛南盆地旧石器地点群1.png": 53552,
	"./海城仙人洞遗址1.png": 31564,
	"./爪村遗址1.png": 42723,
	"./爪村遗址2.png": 17031,
	"./爪村遗址3.png": 2938,
	"./爪村遗址4.png": 61259,
	"./玉米洞遗址1.png": 37039,
	"./玉米洞遗址2.png": 1925,
	"./玉米洞遗址3.png": 72851,
	"./玉米洞遗址4.png": 48461,
	"./甘棠箐遗址1.png": 86414,
	"./甘棠箐遗址2.png": 38382,
	"./甜水沟遗址1.png": 90567,
	"./甜水沟遗址2.png": 33936,
	"./田园洞人1.png": 61195,
	"./白龙洞遗址1.png": 54829,
	"./盘县大洞遗址1.png": 90421,
	"./穿洞遗址1.png": 97395,
	"./穿洞遗址2.png": 40617,
	"./织机洞遗址1.png": 65425,
	"./织机洞遗址2.png": 2498,
	"./花石浪遗址1.png": 32873,
	"./花石浪遗址2.png": 55055,
	"./苏巴什佛寺遗址.png": 56999,
	"./萨拉乌苏遗址1.png": 46302,
	"./萨拉乌苏遗址2.png": 83740,
	"./萨拉乌苏遗址3.png": 65489,
	"./蓝田猿人遗址1.png": 12824,
	"./蓝田猿人遗址2.png": 42145,
	"./蘑菇山北遗址1.png": 79226,
	"./蘑菇山北遗址2.png": 9318,
	"./蘑菇山北遗址3.png": 2391,
	"./虎头梁遗址1.png": 74932,
	"./虎头梁遗址2.png": 97891,
	"./西侯度遗址1.png": 28270,
	"./西侯度遗址2.png": 82179,
	"./西侯度遗址3.png": 17880,
	"./西侯度遗址4.png": 69153,
	"./许家窑－侯家窑遗址1.png": 35573,
	"./许家窑－侯家窑遗址2.png": 44543,
	"./通天洞遗址1.png": 22535,
	"./通天洞遗址2.png": 38645,
	"./那赖遗址1.png": 38739,
	"./金斯太洞穴遗址1.png": 41201,
	"./金斯太洞穴遗址2.png": 29195,
	"./金牛山遗址1.png": 46803,
	"./金牛山遗址2.png": 5567,
	"./金牛山遗址3.png": 95669,
	"./陈山遗址1.png": 74583,
	"./陈山遗址2.png": 42389,
	"./青塘遗址1.png": 1704,
	"./青塘遗址2.png": 97740,
	"./青塘遗址3.png": 66110,
	"./骆驼石旧石器遗址1.png": 28987,
	"./骆驼石旧石器遗址2.png": 94155,
	"./高安上湖遗址1.png": 56104,
	"./鸡公山遗址1.png": 18932,
	"./鸡公山遗址2.png": 59932,
	"./鸽子山遗址1.png": 9583,
	"./鸽子山遗址2.png": 81523,
	"./鸽子山遗址3.png": 22562,
	"./鸽子洞遗址1.png": 12717,
	"./鸽子洞遗址2.png": 31938,
	"./鸽子洞遗址3.png": 94863,
	"./鸽子洞遗址4.png": 90763,
	"./黔西观音洞遗址1.png": 41731,
	"./黔西观音洞遗址2.png": 95483,
	"./龙岗寺遗址1.png": 94939,
	"./龙岗寺遗址2.png": 99202
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 36055;